import * as React from 'react';
import Alert, { AlertCategoryEnum } from '../misc/components/Alert';
import { logReactErrorToServer } from "./LogErrorToServer";

export interface ErrorBoundaryState {
    error: Error;
    errorInfo: React.ErrorInfo;
}

declare var rootUrl: string;

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })

        logReactErrorToServer(error, errorInfo);
        
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    Unfortunately an error has occurred.  The error details have been recorded. We apologize for any inconvenience caused. Please let us know by contacting Vitalograph Support Services
                </Alert>
            );
        }

        return this.props.children;
    }
}
